import { Box, Heading, Text } from '@wix/design-system'
import { useContent, useNext } from '@wix/funnel-builder-lizard'
import { ArrowRight } from '@wix/wix-ui-icons-common'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useBrowserTabTitle } from '../../../hooks/useBrowserTabTitle'
import { WixStudioMobileHeader } from '../../reusable/WixStudioMobileHeader'
import type { Content } from './Content'
import s from './WixStudioMobileSplit.scss'

export const WixStudioMobileSplit: FC = () => {
  const { content } = useContent<Content>()
  const { questionKey, options } = content.question
  useBrowserTabTitle(content.browserTabTitle)

  const pageLogger = usePageLogger()
  const next = useNext()

  useEffect(() => {
    pageLogger.screenView()
  }, [pageLogger])

  const handleClick = (optionKey: string) => () => {
    pageLogger.answer({ answer: optionKey, questionName: questionKey })
    next({ [questionKey]: { values: [optionKey] } })
  }

  const handleBack = () => {
    pageLogger.back()
    window.history.back()
  }

  return (
    <Box direction="vertical" height="100vh" width="100vw" className={s.container}>
      <WixStudioMobileHeader onBackClick={handleBack} />
      <Box direction="vertical" width="100%" align="center" padding="40px 20px 20px" boxSizing="border-box">
        <Box textAlign="center" marginBottom="12px">
          <Heading size="large" className={s.title}>
            {content.title}
          </Heading>
        </Box>
        <Box textAlign="center" marginBottom="32px">
          <Text size="small" className={s.subtitle}>
            {content.subtitle}
          </Text>
        </Box>
        <Box direction="vertical" width="100%" gap="12px">
          {options.map(option => (
            <div key={option.optionKey} className={s.button} onClick={handleClick(option.optionKey)}>
              <Text>{option.label}</Text>
              <ArrowRight color="#116DFF" style={{ flexShrink: 0 }} />
            </div>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
